import { IAlertEventModel } from "../../../Services/AlertService";

export const normalizeAlertEvent = (event?: IAlertEventModel | null): IAlertEventModel | null => {
    if (!event) {
        return null;
    }

    const payload = event.payload ?? {};
    const normalizedEventType = (event.eventType || "").toLowerCase();

    if (normalizedEventType === "message") {
        return {
            ...event,
            eventType: "comment",
            payload,
        };
    }

    const payloadEvent = typeof payload.event === "string" ? payload.event.trim().toLowerCase() : "";
    if (payloadEvent === "criteria_manual_input" || normalizedEventType === "criteria_manual_input") {
        return {
            ...event,
            eventType: "criteria_manual_input",
            payload,
        };
    }

    if (normalizedEventType === "system_message" || normalizedEventType === "systemmessage") {
        const text = typeof payload.text === "string" ? payload.text : "";
        if (text === "created") {
            return {
                ...event,
                eventType: "created",
                payload: {},
            };
        }
        if (text.startsWith("status_change:")) {
            const transition = text.substring("status_change:".length);
            const [from = "", to = ""] = transition.split("->");
            return {
                ...event,
                eventType: "status_change",
                payload: {
                    from,
                    to,
                },
            };
        }
        if (payloadEvent) {
            return {
                ...event,
                eventType: payloadEvent,
                payload,
            };
        }
    }

    if (normalizedEventType === "alert_triggered") {
        const text = typeof payload.text === "string" ? payload.text : "";
        return {
            ...event,
            eventType: "alert_triggered",
            payload: text ? { text, ...payload } : payload,
        };
    }

    if (normalizedEventType === "mail_message" || normalizedEventType === "mailmessage" || normalizedEventType === "email_sent") {
        const text = typeof payload.text === "string" ? payload.text : "";
        const mappedPayload: Record<string, string> = {};

        text.split(";").map((part) => part.trim()).filter(Boolean).forEach((part) => {
            const separatorIndex = part.indexOf("=");
            if (separatorIndex > -1) {
                const key = part.substring(0, separatorIndex).trim();
                const value = part.substring(separatorIndex + 1).trim();
                mappedPayload[key] = value;
            }
        });

        return {
            ...event,
            eventType: "email_sent",
            payload: Object.keys(mappedPayload).length > 0 ? mappedPayload : payload,
        };
    }

    return {
        ...event,
        eventType: normalizedEventType || event.eventType,
        payload,
    };
};
